/**
 * 認証関連のヘルパー関数
 */

/**
 * ユーザーが教師権限を持つかチェック
 * @param {Object} currentUser - 現在のユーザー情報
 * @returns {boolean} 教師権限を持つかどうか
 */
export const isTeacherUser = (currentUser) => {
  return currentUser && (currentUser.role === 'teacher' || currentUser.isMaster);
};

/**
 * ユーザーがマスター権限を持つかチェック
 * @param {Object} currentUser - 現在のユーザー情報
 * @returns {boolean} マスター権限を持つかどうか
 */
export const isMasterUser = (currentUser) => {
  return currentUser && currentUser.isMaster;
};

/**
 * ユーザーが生徒かチェック
 * @param {Object} currentUser - 現在のユーザー情報
 * @returns {boolean} 生徒かどうか
 */
export const isStudentUser = (currentUser) => {
  return currentUser && currentUser.role === 'student';
};

/**
 * ユーザーの表示名を取得
 * @param {Object} user - ユーザー情報
 * @returns {string} 表示名
 */
export const getUserDisplayName = (user) => {
  if (!user) return '未選択';
  return user.name || user.username || 'ユーザー';
};

/**
 * ユーザーの権限レベルを取得
 * @param {Object} currentUser - 現在のユーザー情報
 * @returns {string} 権限レベル ('master', 'teacher', 'student')
 */
export const getUserRole = (currentUser) => {
  if (!currentUser) return 'guest';
  if (currentUser.isMaster) return 'master';
  if (currentUser.role === 'teacher') return 'teacher';
  if (currentUser.role === 'student') return 'student';
  return 'guest';
}; 